import _ from 'underscore';
import { useState, useEffect } from 'react';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';

export const useAutomatedCTA = ({ isMMAAutomatedCTAOptInEnabled, campaignId }) => {
  const [automatedCTAEnable, setAutomatedCTAEnable] = useState(false);

  useEffect(() => {
    if (isMMAAutomatedCTAOptInEnabled && jsdata.Campaign && campaignId && edmCampaign.currentAccount) {
      const params = {
        queryParameters: {
          entitySet: edmCampaign.currentAccount.Campaigns,
        },
        bypassCache: true,
      };
      jsdata.Campaign.find(campaignId, params).then((data) => {
        const campaignSettings = data.CampaignSettings;
        const callToActionSetting = campaignSettings && _.find(campaignSettings, setting => setting['@odata.type'] === '#Model.CallToActionSetting');
        setAutomatedCTAEnable(!callToActionSetting || !callToActionSetting.AutomatedCallToActionOptOut);
      });
    }
  }, [campaignId, isMMAAutomatedCTAOptInEnabled]);

  return automatedCTAEnable;
};
